import(/* webpackMode: "eager" */ "/codebuild/output/src1347810820/src/github.com/Singularity-DAO/sfi-frontend/apps/dapp/app/page.tsx");
